import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
	const toggleButtons =
		document.querySelectorAll<HTMLElement>('[data-toggle-nav]');

	toggleButtons.forEach((toggleButton) => {
		const elementSelector = toggleButton.getAttribute('data-toggle-nav');
		if (!elementSelector) return;

		const toggleClass =
			toggleButton.getAttribute('data-toggle-nav-class') ?? 'open';

		const element = document.querySelector<HTMLElement>(elementSelector);
		if (!element) return;

		const open = () => {
			toggleButton.setAttribute('aria-expanded', 'true');
			element.classList.add(toggleClass);
			disableBodyScroll(element);
		};

		const close = () => {
			toggleButton.setAttribute('aria-expanded', 'false');
			element.classList.remove(toggleClass);
			enableBodyScroll(element);
		};

		toggleButton.addEventListener('click', () => {
			if (!element) return;

			if (toggleButton.getAttribute('aria-expanded') == 'false') {
				open();
			} else {
				close();
			}
		});

		document.addEventListener('click', (event: MouseEvent) => {
			if (
				toggleButton.getAttribute('aria-expanded') == 'true' &&
				toggleButton !== event.target &&
				event.target instanceof HTMLElement &&
				!element.contains(event.target)
			) {
				close();
			}
		});
	});
});
